import { GenerateShareLinkRequest } from 'libs/end-to-end/src/links';
import { GenerateShareLinkResult } from 'libs/end-to-end/src/links';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { UserAuthenticatedApiCall } from 'apps/sigma2-ui/src/state/user-types';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';

export const callGenerateShareLink = async ({
  windowUrl,
  customVizRequest,
  userAuthenticatedApiCall,
}: {
  windowUrl: string;
  customVizRequest: CustomVizRequest;
  userAuthenticatedApiCall: UserAuthenticatedApiCall;
}): Promise<GenerateShareLinkResult | null> => {
  const requestBody: GenerateShareLinkRequest = {
    baseUrl: windowUrl,
    request: customVizRequest,
  };

  const generateShareLinkResult = await userAuthenticatedApiCall({
    url: `${getApiBaseUrl()}/share/generate`,
    requestOptions: {
      method: 'POST',
      body: JSON.stringify(requestBody),
    },
    responseSchema: GenerateShareLinkResult,
  });
  if (
    !generateShareLinkResult ||
    generateShareLinkResult.resultType === 'err'
  ) {
    return null;
  }

  return generateShareLinkResult.value;
};
